/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  DeliveryWindowsResponse,
// @ts-ignore
  Supplier,
// @ts-ignore
  SupplierCreateRequest,
// @ts-ignore
  SupplierListResponse,
// @ts-ignore
  SupplierUpdateRequest,
// @ts-ignore
  UpdateSupplierRetailers,
// @ts-ignore
  UpdateSupplierStores,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    DeliveryWindowsResponseFromJSON,
// @ts-ignore
    DeliveryWindowsResponseToJSON,
// @ts-ignore
    SupplierFromJSON,
// @ts-ignore
    SupplierToJSON,
// @ts-ignore
    SupplierCreateRequestFromJSON,
// @ts-ignore
    SupplierCreateRequestToJSON,
// @ts-ignore
    SupplierListResponseFromJSON,
// @ts-ignore
    SupplierListResponseToJSON,
// @ts-ignore
    SupplierUpdateRequestFromJSON,
// @ts-ignore
    SupplierUpdateRequestToJSON,
// @ts-ignore
    UpdateSupplierRetailersFromJSON,
// @ts-ignore
    UpdateSupplierRetailersToJSON,
// @ts-ignore
    UpdateSupplierStoresFromJSON,
// @ts-ignore
    UpdateSupplierStoresToJSON,
} from '../models/index';

export interface CreateSupplierRequest {
    supplierCreateRequest: SupplierCreateRequest;
}

export interface DeleteSupplierRequest {
    id: string;
}

export interface GetDeliveryWindowsRequest {
    storeId?: string;
    supplierId?: Array<string>;
    lookAheadInWeeks?: number;
}

export interface GetSupplierRequest {
    id: string;
}

export interface ListSuppliersRequest {
    query?: string;
    limit?: number;
    offset?: number;
    supplierId?: Array<string>;
    createdByStoreId?: string;
    sortBy?: Array<string>;
    sortDirection?: Array<ListSuppliersSortDirectionEnum>;
    products?: boolean;
}

export interface UpdateSupplierRequest {
    id: string;
    supplierUpdateRequest: SupplierUpdateRequest;
}

export interface UpdateSupplierRetailersRequest {
    id: string;
    updateSupplierRetailers: UpdateSupplierRetailers;
}

export interface UpdateSupplierStoresRequest {
    id: string;
    updateSupplierStores: UpdateSupplierStores;
}

/**
 * 
 */
export class SuppliersApi extends runtime.BaseAPI {

    /**
     * Create a new supplier
     */
    async createSupplierRaw(requestParameters: CreateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplier>> {
        if (requestParameters.supplierCreateRequest === null || requestParameters.supplierCreateRequest === undefined) {
            throw new runtime.RequiredError('supplierCreateRequest','Required parameter requestParameters.supplierCreateRequest was null or undefined when calling createSupplier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/suppliers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierCreateRequestToJSON(requestParameters.supplierCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierFromJSON(jsonValue));
    }

    /**
     * Create a new supplier
     */
    async createSupplier(requestParameters: CreateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplier> {
        const response = await this.createSupplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a supplier by ID
     */
    async deleteSupplierRaw(requestParameters: DeleteSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteSupplier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/suppliers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a supplier by ID
     */
    async deleteSupplier(requestParameters: DeleteSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSupplierRaw(requestParameters, initOverrides);
    }

    /**
     * Get possible delivery and pickup windows
     */
    async getDeliveryWindowsRaw(requestParameters: GetDeliveryWindowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryWindowsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.lookAheadInWeeks !== undefined) {
            queryParameters['lookAheadInWeeks'] = requestParameters.lookAheadInWeeks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/suppliers/delivery-windows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryWindowsResponseFromJSON(jsonValue));
    }

    /**
     * Get possible delivery and pickup windows
     */
    async getDeliveryWindows(requestParameters: GetDeliveryWindowsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryWindowsResponse> {
        const response = await this.getDeliveryWindowsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a supplier by ID
     */
    async getSupplierRaw(requestParameters: GetSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Supplier>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupplier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/suppliers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierFromJSON(jsonValue));
    }

    /**
     * Get a supplier by ID
     */
    async getSupplier(requestParameters: GetSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Supplier> {
        const response = await this.getSupplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all suppliers
     */
    async listSuppliersRaw(requestParameters: ListSuppliersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.supplierId) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.createdByStoreId !== undefined) {
            queryParameters['createdByStoreId'] = requestParameters.createdByStoreId;
        }

        if (requestParameters.sortBy) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sortDirection) {
            queryParameters['sortDirection'] = requestParameters.sortDirection;
        }

        if (requestParameters.products !== undefined) {
            queryParameters['products'] = requestParameters.products;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/suppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierListResponseFromJSON(jsonValue));
    }

    /**
     * Get all suppliers
     */
    async listSuppliers(requestParameters: ListSuppliersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierListResponse> {
        const response = await this.listSuppliersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a supplier by ID
     */
    async updateSupplierRaw(requestParameters: UpdateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupplier.');
        }

        if (requestParameters.supplierUpdateRequest === null || requestParameters.supplierUpdateRequest === undefined) {
            throw new runtime.RequiredError('supplierUpdateRequest','Required parameter requestParameters.supplierUpdateRequest was null or undefined when calling updateSupplier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/suppliers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierUpdateRequestToJSON(requestParameters.supplierUpdateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a supplier by ID
     */
    async updateSupplier(requestParameters: UpdateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierRaw(requestParameters, initOverrides);
    }

    /**
     * Update the retailers associated with the supplier
     */
    async updateSupplierRetailersRaw(requestParameters: UpdateSupplierRetailersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupplierRetailers.');
        }

        if (requestParameters.updateSupplierRetailers === null || requestParameters.updateSupplierRetailers === undefined) {
            throw new runtime.RequiredError('updateSupplierRetailers','Required parameter requestParameters.updateSupplierRetailers was null or undefined when calling updateSupplierRetailers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/suppliers/{id}/retailers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplierRetailersToJSON(requestParameters.updateSupplierRetailers),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the retailers associated with the supplier
     */
    async updateSupplierRetailers(requestParameters: UpdateSupplierRetailersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierRetailersRaw(requestParameters, initOverrides);
    }

    /**
     * Update the stores associated with the supplier
     */
    async updateSupplierStoresRaw(requestParameters: UpdateSupplierStoresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupplierStores.');
        }

        if (requestParameters.updateSupplierStores === null || requestParameters.updateSupplierStores === undefined) {
            throw new runtime.RequiredError('updateSupplierStores','Required parameter requestParameters.updateSupplierStores was null or undefined when calling updateSupplierStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/suppliers/{id}/stores`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplierStoresToJSON(requestParameters.updateSupplierStores),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the stores associated with the supplier
     */
    async updateSupplierStores(requestParameters: UpdateSupplierStoresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierStoresRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListSuppliersSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListSuppliersSortDirectionEnum = typeof ListSuppliersSortDirectionEnum[keyof typeof ListSuppliersSortDirectionEnum];
